<template>
<div class="card card-missing">
  <div class="card-icon">
    <fa icon="exclamation-circle"/>
  </div>

  <div class="message">
    <h4>Error with ISRC {{ isrc }} in {{ provider }}</h4>
    <p class="description">{{ message }}</p>
  </div>
</div>
</template>

<script>
export default {
  name: "TrackMissing",

  props: {
    isrc: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.card-missing {
  background-color: rgba(#f48a06, 0.25);
  display: flex;
  padding: 10px 20px;
}

.card-icon {
  width: 100px;
  font-size: 2.25em;
  position: relative;
  padding: 20px 0;
}

.message {
  width: calc(100% - 100px);
  text-align: left;

}
</style>
